const APP_SWITCHER_ICON_CLICKED = "App Switcher Icon Clicked";
const TOOLWATCH_LOGIN_CLICKED = "ToolWatch Login Clicked";
const FLEETWATCHER_LOGIN_CLICKED = "FleetWatcher Login Clicked";
const SAFETYREPORTS_LOGIN_CLICKED = "SafetyReports Login Clicked";
const BUSYBUSY_LOGIN_CLICKED = "BusyBusy Login Clicked";
const TOOLWATCH_LEARN_MORE_CLICKED = "ToolWatch Learn More Clicked";
const FLEETWATCHER_LEARN_MORE_CLICKED = "FleetWatcher Learn More Clicked";
const SAFETYREPORTS_LEARN_MORE_CLICKED = "SafetyReports Learn More Clicked";
const BUSYBUSY_LEARN_MORE_CLICKED = "BusyBusy Learn More Clicked";

const webAppSwitcherAnalyticsConstants = {
    APP_SWITCHER_ICON_CLICKED,
    TOOLWATCH_LOGIN_CLICKED,
    FLEETWATCHER_LOGIN_CLICKED,
    SAFETYREPORTS_LOGIN_CLICKED,
    BUSYBUSY_LOGIN_CLICKED,
    TOOLWATCH_LEARN_MORE_CLICKED,
    FLEETWATCHER_LEARN_MORE_CLICKED,
    SAFETYREPORTS_LEARN_MORE_CLICKED,
    BUSYBUSY_LEARN_MORE_CLICKED,
}

export default webAppSwitcherAnalyticsConstants;